import { cn } from "@/lib/shadcn-utils"
import { LoadingSpinner } from "@/components/LoadingSpinner"

export function LoadingOverlay() {
  return (
    <div
      className={cn(
        "tw-fixed tw-inset-0 tw-bg-black/50 tw-cursor-wait",
        "tw-flex tw-flex-col tw-items-center tw-justify-center tw-z-[100]",
      )}
    >
      <LoadingSpinner />
    </div>
  )
}
